/**
 * Arduino Custom Product Code Block
 * For liquid template please refer to arduino-product-code.liquid
 */

(function() {
    function mutationCallback(mutationList, observer) {
        for(const mutation of mutationList) {
            if(mutation.type === 'attributes') {
                toggleProductCode(mutation.target);
            }
        }
    }

    function toggleProductCode(variantSelection) {
        const variantId = variantSelection.variant;
        const productDetails = variantSelection.closest('[data-product-details]');
        const productCodes = productDetails.querySelectorAll('.ino-product-code');

        for(let code of productCodes) {
            code.classList.remove('show');

            if(code.dataset.variant === variantId) {
                code.classList.add('show');
            }
        }
    }

    function onShowMoreButtonClick(event) {
        event.preventDefault();

        const productCodes = event.currentTarget.closest('.ino-product-code');
        const metafields = productCodes.querySelectorAll('.ino-metafield');

        if(metafields.length > 0) {
            for(let metafield of metafields) {
                metafield.classList.toggle('hidden');
            }

            if(event.currentTarget.innerHTML == 'Show more') {        
                event.currentTarget.innerHTML = 'Show less';
            } else {
                event.currentTarget.innerHTML = 'Show more';
            }
        }
    }

    function init() {
        // product codes toggle
        const productDetails = document.querySelectorAll('[data-product-details]');

        for(let product of productDetails) {
            const variantSelection = product.querySelector('[data-variant-selection]');

            if(variantSelection) {
                const observer = new MutationObserver(mutationCallback);
                const config = { attributes: true };

                observer.observe(variantSelection, config);
            }
        }

        // show more toggle
        const productCodes = document.querySelectorAll('.ino-product-code');

        for(let code of productCodes) {
            const showMoreButton = code.querySelector('.ino-product-show-more');
            
            if(showMoreButton) {
                showMoreButton.addEventListener('click', onShowMoreButtonClick);
            }
        }
    }

    window.addEventListener('load', init);
})();